import React, { Component } from 'react'
import arrowRight from '../img/right-arrow.svg'
import arrowLeft from '../img/left-arrow.svg'
import avatar from '../img/ava-4.png';
import { FaTelegramPlane } from "react-icons/fa"
import {IoLogoGoogle} from 'react-icons/io'
import {MdMail, MdPhoneAndroid, MdStarBorder} from "react-icons/md"

export default class About extends Component {
    render() {
        return (
            <div className="about">
                <div className="title">
                    <div className="title__img">
                        <img src={arrowLeft} height="25px" alt="arrow right"/>
                    </div>
                    <div className="title__heading">
                        <h1>About me</h1>
                    </div>
                    <div className="title__img">
                        <img src={arrowRight} height="25px" alt="arrow right"/>
                    </div>
                </div>
                <div className="about-title">
                    <span className="about-title__meet">Meet</span>
                    <h3 className="about-title__heading">Front-end Developer</h3>
                </div>
                <div className="about-content">
                    <div className="about-content__top about-content-top">
                        <div className="about-content-top__text">
                            Assalamu alaykum! I am Karimov Jamshid, front-end developer from Tashkent, Uzbekistan.
                            I make responsive and cross-browser websites using PSD templates. I code using languages 
                            HTML5, CSS3, PugJS (Jade), Sass, Less or Stylus. BEM method is used to make structure 
                            of the code readable and understandable. I use Gulp4 for comfortable coding. 
                            Necessary level of JavaScript, ES6 and JQuery for front-end development.  
                        </div>
                        <div className="about-content-top__img">
                            <img src={avatar} alt="avatar"/>
                        </div>
                    </div>
                    <div className="about-content-bottom">
                        <div className="about-content-bottom__text">
                            Self study has played very important role in my code learning. I have 
                            studied in several educational centers, but they were not much 
                            useful for me. In my opinion learning by watching video tutorials 
                            much more efficient, because you can pause, play back or
                            watch again any time. Especially YouTube video tutorials are real treasure
                            for learning coding. Here is a list of YouTube channels I use and recommend to coders:
                            <ul className="about-content-bottom__list">
                                <div className="connect-list__top">
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCqGjCzCi5zG3RjJUA-ZDBkQ" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">BrainsCloud</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCtOmmC3Z8WSn45VgTAKBHhA" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">CodeAndCreate</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCMZFwxv5l-XtKi693qMJptA" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">Coding Addict</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCVyRiMvfUNMA1UPlDPzG5Ow" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">DesignCourse</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UC8butISFwT-Wl7EV0hUK0BQ" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">freeCodeCamp.org</li>
                                    </a>
                                </div>
                                <div className="connect-list__bottom">
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCzhKcnzGNhPEZsNSKjug1jA" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">FrontCoder.org</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCeHWTyAKBv_WnW8gsEKGECw" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">Julio Codes</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UCWv7vMbMWH4-V0ZXdmDpPBA" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">Programming with Mosh</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UC29ju8bIPH5as8OGnQzwJyA" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">Traversy Media</li>
                                    </a>
                                    <a className="about-content-bottom__link" href="https://www.youtube.com/channel/UC7enHM_oJRYJOnyJrcRzwbg" target="_blank" rel="noopener noreferrer">
                                        <MdStarBorder className="about__icon connect-icon"/>
                                        <li className="about-content-bottom__li">WebDesign Master</li>
                                    </a>
                                </div>
                               
                            </ul>
                        </div>
                        <div className="about-content-bottom__connect">
                            <h3 className="about-content-bottom__heading">Let's connect</h3>
                            <div className="connect__container">
                                <div className="about-content-bottom__item">
                                    <IoLogoGoogle className="about__icon"/>
                                    <span>jamshid1997karimov@gmail.com</span>
                                </div>
                                <div className="about-content-bottom__item">
                                    <FaTelegramPlane className="about__icon"/>
                                    <span>https://t.me/Karimov_Jamshid</span>
                                </div>
                                <div className="about-content-bottom__item">
                                    <MdMail className="about__icon"/>
                                    <span>jamshid97karimov@mail.ru</span>
                                </div>
                                <div className="about-content-bottom__item">
                                    <MdPhoneAndroid className="about__icon"/>
                                    <span>+998 97 447 01 34</span>
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
